var image_upload_default = {
  "container": "s8bOH",
  "disabled": "_2sFSw",
  "imageInput": "_8Yxmh",
  "overlay": "BOGx1",
  "text": "_2OJIa",
  "shown": "QvmZ-",
  "hide": "dJ9zb",
  "spinner": "Z82kH",
  "spin": "nFfAF"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
